/**
 * Common enum for entity allowed actions
 * Used across different entities (projects, team members, etc.)
 */
export enum AllowedAction {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}
